import { Component, OnInit, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { CaceisIcons } from '../../icons/caceis-icon/caceis-icon.component';
import { DialogBoxService } from '../dialog-box-service';
import { SnackbarModel } from './snackbar.model';

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
})
export class SnackbarComponent implements OnInit {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public model: SnackbarModel) { }

  ngOnInit() { }

  closeAlert() {
    if (DialogBoxService.snackbarRef != null) DialogBoxService.snackbarRef.dismiss();
  }
}



export enum SnackbarVerticalPosition {
  top = 'top',
  bottom = 'bottom',
  center = 'center',
}

export enum SnackbarHorizontalPosition {
  left = 'left',
  right = 'right',
  center = 'center',
}

export enum SnackbarTheme {
  info = 'snackbar-info',
  error = 'snackbar-error',
  warn = 'snackbar-warn',
  success = 'snackbar-success',
  load ='snackbar-load'
}
